import React from "react";

const TopMarqueePremium = () => {
  return (
    <div className="relative w-full overflow-hidden bg-gradient-to-r from-[#0f172a] via-[#020617] to-black text-white">

      {/* 🔥 Glow Effect */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_30%_50%,#3b82f6,transparent_40%),radial-gradient(circle_at_70%_50%,#ec4899,transparent_40%)]"></div>

      {/* 🔥 Blur Glass */}
      <div className="relative backdrop-blur-md border-b border-white/10">

        <div className="flex whitespace-nowrap animate-[marquee_20s_linear_infinite] py-2 text-sm font-medium">

          {[
            "🔥 Mega Sale Live Now",
            "🎁 Use Code: LAPPY100",
            "🚚 Free Delivery Available",
            "💻 Up to 70% OFF",
            "⚡ Limited Time Deal",
          ].map((text, i) => (
            <span
              key={i}
              className="mx-6 flex items-center gap-2 px-4 py-1 rounded-full bg-white/10 hover:bg-white/20 transition"
            >
              {text}
            </span>
          ))}

          {/* duplicate for smooth loop */}
          {[
            "🔥 Mega Sale Live Now",
            "🎁 Use Code: LAPPY100",
            "🚚 Free Delivery Available",
            "💻 Up to 70% OFF",
            "⚡ Limited Time Deal",
          ].map((text, i) => (
            <span
              key={"dup-" + i}
              className="mx-6 flex items-center gap-2 px-4 py-1 rounded-full bg-white/10"
            >
              {text}
            </span>
          ))}

        </div>
      </div>

      {/* 🔥 Edge Fade */}
      <div className="absolute left-0 top-0 h-full w-20 bg-gradient-to-r from-black to-transparent pointer-events-none"></div>
      <div className="absolute right-0 top-0 h-full w-20 bg-gradient-to-l from-black to-transparent pointer-events-none"></div>

      {/* 🔥 INLINE KEYFRAME (NO CONFIG ERROR) */}
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </div>
  );
};

export default TopMarqueePremium;